<template>
  <div class="cute-timeline-item">
    <span class="cute-timeline-item__others">
      <slot name="others"></slot>
    </span>
    <div class="cute-timeline-item__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimelineItem'
}
</script>

<style scoped>
.cute-timeline-item {
  display: flex;
  align-items: flex-start;
  padding: 4px 0;
  gap: 6px;
}
.cute-timeline-item__others {
  flex-shrink: 0;
}
.cute-timeline-item__content {
  flex: 1;
}
</style>
